import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UploadFormContainer } from '@app/my-zone/shared/paperwork/documentary-evidence/upload-form/upload-form.container';
import { PaperworkContainer } from '@app/my-zone/shared/paperwork/paperwork.container';
import { CynoFormModule } from '@app/shared/cyno-form/cyno-form.module';
import { ClickTooltipModule } from '@app/shared/ux/click-tooltip/click-tooltip.module';
import { ListModule } from '@app/shared/ux/lists/list.module';
import { NgxUploaderModule } from '@angular-ex/uploader';
import { ConfirmationModalModule } from '../modals/confirmation-modal/confirmation-modal.module';
import { DocumentaryEvidenceComponent } from './documentary-evidence/documentary-evidence.component';
import { UploadFormComponent } from './documentary-evidence/upload-form/upload-form.component';
import { PaperworkComponent } from './paperwork.component';

@NgModule({
    declarations: [
        DocumentaryEvidenceComponent,
        PaperworkComponent,
        UploadFormComponent,
        PaperworkContainer,
        UploadFormContainer,
    ],
    imports: [CommonModule, NgxUploaderModule, CynoFormModule, ListModule, ClickTooltipModule, ConfirmationModalModule],
    exports: [PaperworkContainer],
    providers: [],
})
export class PaperworkModule {}
